export const BENEFITS_METRICS_DEFAULT_RANGE_DAYS = 30;

export const startOfDayIso = (date: Date): string => {
  const value = new Date(date);
  value.setHours(0, 0, 0, 0);
  return value.toISOString();
};

export const endOfDayIso = (date: Date): string => {
  const value = new Date(date);
  value.setHours(23, 59, 59, 999);
  return value.toISOString();
};

export const defaultBenefitsMetricsDateFrom = (): Date => {
  const date = new Date();
  date.setDate(date.getDate() - (BENEFITS_METRICS_DEFAULT_RANGE_DAYS - 1));
  date.setHours(0, 0, 0, 0);
  return date;
};

export const defaultBenefitsMetricsDateTo = (): Date => {
  const date = new Date();
  date.setHours(23, 59, 59, 999);
  return date;
};
